// @flow

import React, { type Node } from 'react';
import { getSafeCountryFromCode, CountryProvider } from '@tectonics/commons/country';
import { getTenantFromCode, TenantProvider } from '@tectonics/commons/tenant';
import { PublicIntegrationKeyProvider } from '@tectonics/commons/public-integration-key';
import { PaymentMethodsProvider } from '@tectonics/commons/payment-methods';
import { getQueryParamValueOrCry } from '@tectonics/commons/query-params';
import { LookAndFeelRouter } from './look-and-feel';

export function AddPaymentMethodController({ tenantCode, lookAndFeelCode }: Props): Node {
  if (!tenantCode) {
    throw new Error('URL query param "tenant" not found');
  }

  const publicIntegrationKeySearch = /pk=([^&#$]+)/.exec(window.location.search);
  const paymentMethodSearch = /pm=([^&#$]+)/.exec(window.location.search);

  if (!publicIntegrationKeySearch || publicIntegrationKeySearch.length < 2) {
    throw new Error('Public integration key not specificed');
  }

  if (!paymentMethodSearch || paymentMethodSearch.length < 2) {
    throw new Error('Payment method not specificed');
  }

  const publicIntegrationKey = publicIntegrationKeySearch[1];
  const paymentMethods = [ paymentMethodSearch[1] ];
  const tenant = getTenantFromCode(tenantCode);
  const countryCode = getQueryParamValueOrCry('country_code');
  const country = getSafeCountryFromCode(countryCode);

  return (
    <TenantProvider value={tenant}>
      <CountryProvider value={country}>
        <PublicIntegrationKeyProvider value={publicIntegrationKey}>
          <PaymentMethodsProvider value={paymentMethods}>
            <LookAndFeelRouter lookAndFeelCode={lookAndFeelCode || 'uber'} />
          </PaymentMethodsProvider>
        </PublicIntegrationKeyProvider>
      </CountryProvider>
    </TenantProvider>
  );
}

type Props = {
  tenantCode: ?string,
  lookAndFeelCode: ?string,
};
